import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { ATTENDANCE_PERMISSIONS } from '@/constants/permissions';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { EmployeeReportPage } from '@/features/attendance/pages/EmployeeReportPage';
import { shiftEmployeeReportQueryOptions } from '@/features/attendance/api/attendance.api';

const searchSchema = z.object({
  userId: z.number(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

export const Route = createFileRoute('/_auth/attendance/shift-employee-report')({
  beforeLoad: () => requirePermission(ATTENDANCE_PERMISSIONS.SHIFT_JOB_CARD_VIEW),
  validateSearch: searchSchema,
  component: function ShiftEmployeeReportRoute() {
    const { userId, dateFrom, dateTo } = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Shift Employee Report">
        <Suspense fallback={<PageLoader />}>
          <EmployeeReportPage
            queryOptions={shiftEmployeeReportQueryOptions}
            userId={userId}
            {...(dateFrom !== undefined && { dateFrom })}
            {...(dateTo !== undefined && { dateTo })}
            title="Employee Report (Night Shift)"
          />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
